/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoCorrections } from './CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoCorrections';
import {
    CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoCorrectionsFromJSON,
    CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoCorrectionsFromJSONTyped,
    CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoCorrectionsToJSON,
} from './CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoCorrections';

/**
 * 
 * @export
 * @interface CreateOrUpdateBeamAnalysisTaskItemAreaDataDto
 */
export interface CreateOrUpdateBeamAnalysisTaskItemAreaDataDto {
    /**
     * 
     * @type {CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoCorrections}
     * @memberof CreateOrUpdateBeamAnalysisTaskItemAreaDataDto
     */
    corrections?: CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoCorrections | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateBeamAnalysisTaskItemAreaDataDto
     */
    $type?: CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoTypeEnum;
}


/**
 * @export
 */
export const CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoTypeEnum = {
    PtwPtw100BeamAnalysisApplicationTaskItemComponentDtoCreateOrUpdateBeamAnalysisTaskItemAreaDataDtoPtwPtw100BeamAnalysisApplication: 'Ptw.Ptw100.BeamAnalysis.Application.TaskItemComponent.Dto.CreateOrUpdateBeamAnalysisTaskItemAreaDataDto, Ptw.Ptw100.BeamAnalysis.Application'
} as const;
export type CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoTypeEnum = typeof CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoTypeEnum[keyof typeof CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoTypeEnum];



/**
 * Check if a given object implements the CreateOrUpdateBeamAnalysisTaskItemAreaDataDto interface.
 */
export function instanceOfCreateOrUpdateBeamAnalysisTaskItemAreaDataDto(value?: unknown): value is CreateOrUpdateBeamAnalysisTaskItemAreaDataDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoTypeEnum)[0];
}

export function CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoFromJSON(json: any): CreateOrUpdateBeamAnalysisTaskItemAreaDataDto {
    return CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoFromJSONTyped(json, false);
}

export function CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateBeamAnalysisTaskItemAreaDataDto {
    if (json == null) {
        return json;
    }
    return {
        
        'corrections': json['corrections'] == null ? undefined : CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoCorrectionsFromJSON(json['corrections']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoToJSON(value?: CreateOrUpdateBeamAnalysisTaskItemAreaDataDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'corrections': CreateOrUpdateBeamAnalysisTaskItemAreaDataDtoCorrectionsToJSON(value['corrections']),
        '$type': value['$type'],
    });
}

